import { AppThunk } from 'redux/reducers/rootReducer';
import { ITableQueryData } from 'types/frontend_models/table/ITableQueryData';
import { defaultDataTablePageSize } from 'functions/tables/TableFunctions';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IGenericDataFetchParams, createGenericTableDataFetch } from '../generic/GenericDataActions';
import { IInvoice } from 'types/backend_models/invoices/IInvoice';
import { setFetchInvoicesPending, setFetchInvoicesSucces, setFetchInvoicesError } from 'redux/reducers/data_action_reducers/invoices/InvoicesReducer';
import { builBackendTableQuery } from 'functions/backend/backendTableQueryBuilder';

export const initialQueryData: ITableQueryData = {
	sorted: '',
	filters: [],
	currentPage: 1,
	pageSize: defaultDataTablePageSize
}

var lastQueryData: ITableQueryData = initialQueryData;

export function getLastQueryData(): ITableQueryData
{
	return lastQueryData;
}

var fetchParams: IGenericDataFetchParams<ITableData<IInvoice[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchInvoicesPending,
	succesActionCreator: setFetchInvoicesSucces,
	errorActionCreator: setFetchInvoicesError
}

export function fetchInvoices(data: ITableQueryData): AppThunk
{
	lastQueryData = data;
	const query = builBackendTableQuery(data);
	fetchParams.apiEndPoint = `customer/invoices${query}`;

	return createGenericTableDataFetch<IInvoice[]>(fetchParams);
}